import React from "react";
import { Button, Form, Card, Alert, Spinner } from "react-bootstrap";
import { store } from "../../reducer/Store";
import Utils from "../../services/Utils";
import { ToastContainer } from "react-toastify";
import ApiService from "../../services/ApiService";
const RapportPdf2 = () => {

  const { state } = React.useContext(store);

  const today = new Date();

  const [pdf, setPdf] = React.useState({
    challenge: false,
    operation: false,
  });
  const [loader, setLoader] = React.useState(false);
  const handleClose = () => {
    setPdf({
      challenge: false,
      operation: false
    });
  };

  /**
   * La fonction handleSubmitExportPdfClient est utilisée pour soumettre le formulaire et exporter le rapport PDF du client.
   * Elle prend en paramètre e, l'événement de soumission du formulaire.
   * Active le chargement (loader) pour afficher une indication de progression.
   * Empêche le comportement par défaut du formulaire.
   * Prépare les données à envoyer dans la requête en rassemblant les informations nécessaires telles que l'identifiant du client, l'identifiant de l'année, l'identifiant de la marque, 
   * le nom de l'année, et les informations pour l'affichage du rapport (opération et défi).
   * Effectue une requête à l'API pour récupérer le fichier PDF en utilisant les données préparées.
   * En cas de succès de la requête, génère un lien de téléchargement pour le fichier PDF et déclenche le téléchargement.
   * Affiche une notification de succès pour informer l'utilisateur que le rapport PDF a été téléchargé avec succès.
   * En cas d'erreur lors de la requête, affiche une notification d'erreur et affiche le message d'erreur dans la console.
   * @param {*} e 
   */
  const handleSubmitExportPdfClient = async (e) => {
    setLoader(true)
    e.preventDefault();
    const data = {
      customer_id: parseInt(state.dataCustomer.id),
      year_id: parseInt(state.currentYear.value),
      brand_id: parseInt(
        state.currentBrands.length > 0 ? state.currentBrands[0].value : ""
      ),
      year_name: parseInt(state.currentYear.label),
      display_operation: pdf.operation,
      display_challenge: pdf.challenge,
    };

    ApiService.requestBlobFile(data, 'export-pdf-2', "post")
      .then((response) => {
        handleClose()
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Rapporttrade_bimensuel_${
            state.dataCustomer.id +'__'+
            (today.getMonth()+1)+'_'+(today.getMonth()+2)+'__'+
            state.currentYear.label
            }.pdf`
        );
        setLoader(false)
        handleClose()
        document.body.appendChild(link);
        link.click();
        Utils.notifySuccess("Rapport Pdf téléchargé");
      })
      .catch((error) => {
        setLoader(false)
        handleClose()
        Utils.notifyError("du téléchargement du Rapport Pdf");
        console.log(error);
      });
  };
  const handlePdfToExportChange = (field) => {
    return (e) => {
      setPdf((prev) => ({
        ...prev,
        [field]: e.target.checked,
      }));
    };
  };
  return (
    <>
      <h1>
        Rapport bimensuel
      </h1>
      
      {!loader ?
        <Card className="w-100" >
          <Card.Title>
            {" "}
            <h2> Générer le rapport bimensuel</h2>{" "}
          </Card.Title>
          <Form onSubmit={(e) => handleSubmitExportPdfClient(e)}>
            
            <Button variant="success" type="submit" className="mx-2">
              Générer le Pdf bimensuel
            </Button>
          </Form>
        </Card> :
        <div className="text-center pt-5">
          <Spinner
            animation={loader ? "border" : false}
            role="status"
          ></Spinner>
        </div>
      }

    </>
  );
};

export default RapportPdf2;
